
function LoadingSpinner() {
  return (
    <div className="trinity-rings-spinner">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
    </div>
  )
}

export default LoadingSpinner